import React from 'react'
import PropTypes from 'prop-types'
import styles from './QuestionMultChoiceSingleAnswer.css'
import QuestionBlock from '../QuestionBlock'
import RadioQuizAnswer from '../RadioQuizAnswer'

class QuestionMultChoiceSingleAnswer extends React.Component {
  render () {
    let {
      id,
      question,
      answers,
      correctAnswerText,
      incorrectAnswerText,
      selectedAnswer,
      onAnswer,
      readonly,
      forPrint,
      ...otherAttributes
    } = this.props

    const hasCorrectAnswer = answers.reduce((prev, curr) => prev || curr.correctAnswer === 'true', false)
    let answerElements
    answerElements = answers.map((answer, key) => {
      const isCorrect = answer.correctAnswer === 'true'
      const isSelectedAnswer = selectedAnswer === answer.id
      const questionHasSelectedAnswer = !!selectedAnswer
      return (
        <RadioQuizAnswer
          key={key}
          id={answer.id}
          name={id}
          label={answer.answer}
          value={answer.id}
          hasCorrectAnswer={hasCorrectAnswer}
          correctAnswerText={correctAnswerText}
          incorrectAnswerText={incorrectAnswerText}
          showEvaluation={isSelectedAnswer || (isCorrect && questionHasSelectedAnswer)}
          isSelected={isSelectedAnswer}
          isCorrect={isCorrect}
          onAnswer={onAnswer}
          readonly={readonly}
          forPrint={forPrint}
        />
      )
    })

    return (
      <div role="radiogroup" className={'hw-question-mult-choice-single-answer ' + styles.question_mult_choice_single_answer}>
        <QuestionBlock questionId={id} question={question} >
          <div className={'hw-question-mult-choice-single-answer-group ' + styles.question_mult_choice_single_answer_group}>
            {answerElements}
          </div>
        </QuestionBlock>
      </div>
    )
  }
}

QuestionMultChoiceSingleAnswer.propTypes = {
  id: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  selectedAnswer: PropTypes.string,
  correctAnswerText: PropTypes.string,
  incorrectAnswerText: PropTypes.string,
  onAnswer: PropTypes.func,
  answers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    feedback: PropTypes.string,
    correctAnswer: PropTypes.string
  })).isRequired,
  readonly: PropTypes.bool,
  forPrint: PropTypes.bool
}

export default QuestionMultChoiceSingleAnswer



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/QuestionMultChoiceSingleAnswer/index.js